



















import $router from "@/router";
import Product from "@/components/Product.vue";
import store from "@/store";
import LoadingScreen from "@/components/LoadingScreen.vue";
import Vue from "vue";
import { FooterSettings } from "@/models";

const footerSettings: FooterSettings = {
  prevText: "recommendation.footer.prev",
  prevIcon: "fas fa-chevron-left",
  prevAction: function() {
    store.commit("setLoading", {
      loading: true,
      loadingText: "",
      transition: "slide-right"
    });
    $router.push("/before-after");
  },
  prevVisible: true,
  prevEnabled: true,
  nextText: "recommendation.footer.next",
  nextIcon: "fas fa-chevron-right",
  nextAction: function() {
    store.commit("setLoading", {
      loading: true,
      loadingText: "",
      transition: "slide-left"
    });
    $router.push("/finish");
  },
  nextVisible: true,
  nextEnabled: true
};

export default Vue.extend({
  name: "Recommendation",
  components: { LoadingScreen, Product },
  data() {
    return {
      product: 0,
      textHydration: "",
      textWrinkles: ""
    };
  },
  mounted() {
    store.commit("changeFooter", footerSettings);
    this.product = store.state.product;
    if (this.$matomo) {
      this.$matomo.trackEvent(
        "Configuration",
        "Age selection",
        this.$t("matomo.age-selection." + store.state.age)
      );
      this.$matomo.trackEvent(
        "Configuration",
        "Question selection",
        this.$t("matomo.question-selection." + store.state.age)
      );
      this.$matomo.trackEvent(
        "Configuration",
        "Wrinkle selection",
        this.$t("matomo.wrinkle-selection." + store.state.age)
      );
    }
  }
});
